import {NetworkAPIVersion, NetworkParamType} from './network.utils';

export default {
  search: {
    url: 'surname/',
    apiVersion: NetworkAPIVersion.v1_version,
    method: 'get',
    params: {
      start: [NetworkParamType.string],
      limit: [NetworkParamType.number],
      offset: [NetworkParamType.number],
    },
  },
};
